// class to hold reference to the config Filter Groups 
export class Filters {
  static GAUGE_FILTER_ID = 'gaugeFilters';
  static OWNED_BY_FILTER_ID = 'ownedByFilters';
  static STATUS_FILTER_ID = 'statusFilters';
}